import WppBtn from '../../components/WppBtn/WppBtn';
import { Instagram, Location, Phone2 } from '../../components/utils/icons';
import styles from './home.module.scss';

const whatsappUrl =
	'https://wa.me/555130120226?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20Multilentes%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es.';

const products = [
	{
		title: 'Óculos de grau',
		text: 'Armações para diferentes estilos, com orientação para uma escolha confortável e segura.',
		image: '/assets/ImageView/oculos-de-grau.jpeg',
		alt: 'Cliente usando óculos de grau na Multilentes',
	},
	{
		title: 'Óculos solares',
		text: 'Modelos que unem proteção, conforto e personalidade para todos os momentos.',
		image: '/assets/ImageView/oculos-solares.jpeg',
		alt: 'Cliente usando óculos solares na Ótica Multilentes',
	},
	{
		title: 'Lentes de contato',
		text: 'Opções das principais marcas, com atendimento especializado para sua rotina visual.',
		image: '/assets/ImageView/lentes-de-contato.jpeg',
		alt: 'Atendimento especializado em lentes de contato na Multilentes',
	},
];

const partnerLogos = Array.from(
	{ length: 6 },
	(_, index) => `/assets/Brandings/logo${index + 1}.png`
);

function trackWhatsapp(position) {
	if (window.dataLayer) {
		window.dataLayer.push({ event: 'whatsapp_click', position });
	}
}

function WhatsappLink({ children, className, position }) {
	return (
		<a
			href={whatsappUrl}
			target="_blank"
			rel="noreferrer"
			className={className}
			onClick={() => trackWhatsapp(position)}
		>
			{children}
		</a>
	);
}

export default function Home() {
	return (
		<div className={styles.page}>
			<header className={styles.header}>
				<a href="#inicio" className={styles.logoLink} aria-label="Multilentes — início">
					<img src="/assets/logo.png" alt="Ótica Multilentes" />
				</a>
				<nav aria-label="Navegação principal">
					<a href="#produtos">Produtos</a>
					<a href="#diferenciais">Diferenciais</a>
					<a href="#localizacao">Localização</a>
				</nav>
				<WhatsappLink className={styles.headerCta} position="header">
					Fale pelo WhatsApp
				</WhatsappLink>
			</header>

			<main>
				<section id="inicio" className={styles.hero}>
					<div className={styles.heroContent}>
						<p className={styles.eyebrow}>Ótica em São Geraldo · Porto Alegre</p>
						<h1>Enxergue melhor. Sinta-se bem com a sua escolha.</h1>
						<p className={styles.heroText}>
							Há mais de 40 anos, a Multilentes cuida da sua visão com atendimento próximo,
							experiência e produtos de qualidade.
						</p>
						<div className={styles.badges} aria-label="Diferenciais da loja">
							<span><strong>40+ anos</strong> de experiência</span>
							<span><strong>Estacionamento</strong> conveniado</span>
						</div>
						<div className={styles.heroActions}>
							<WhatsappLink className={`${styles.primaryCta} ${styles.whatsappCta}`} position="hero">
								Falar agora no WhatsApp <span aria-hidden="true">→</span>
							</WhatsappLink>
							<a href="#localizacao" className={styles.secondaryCta}>Como chegar</a>
						</div>
						<p className={styles.openingHours}>Segunda a sexta, 9h às 17h30 · Sábado, 9h às 12h por agendamento</p>
					</div>

					<div className={styles.heroGallery} aria-label="Ambiente da Ótica Multilentes">
						<img className={styles.heroMainImage} src="/assets/HomeView/1.jpg" alt="Balcão de atendimento da Ótica Multilentes" />
						<img className={styles.heroDetailImage} src="/assets/selected/oculos-estilo.jpg" alt="Cliente experimentando uma armação na Multilentes" />
						<div className={styles.heroNote}>
							<span>Atendimento especializado</span>
							<strong>Para óculos e lentes que combinam com você</strong>
						</div>
					</div>
				</section>

				<section className={styles.brandStrip} aria-label="Marcas parceiras">
					<p>Qualidade que você reconhece</p>
					<div>
						{partnerLogos.map((logo, index) => (
							<img src={logo} alt={`Marca parceira ${index + 1}`} key={logo} loading="lazy" />
						))}
					</div>
				</section>

				<section id="produtos" className={styles.section}>
					<div className={styles.sectionHeading}>
						<p className={styles.eyebrow}>Encontre o que você precisa</p>
						<h2>Soluções para a sua visão e o seu estilo</h2>
						<p>Conte com nossa equipe para escolher com tranquilidade.</p>
					</div>
					<div className={styles.productGrid}>
						{products.map((product) => (
							<article className={styles.productCard} key={product.title}>
								<img src={product.image} alt={product.alt} loading="lazy" />
								<div>
									<h3>{product.title}</h3>
									<p>{product.text}</p>
									<WhatsappLink position={`produto-${product.title}`}>
										Consultar pelo WhatsApp <span aria-hidden="true">→</span>
									</WhatsappLink>
								</div>
							</article>
						))}
					</div>
				</section>

				<section id="diferenciais" className={styles.experienceSection}>
					<div className={styles.experienceImages}>
						<img src="/assets/selected/atendimento-especializado.jpg" alt="Atendimento personalizado na Ótica Multilentes" loading="lazy" />
						<img src="/assets/selected/precisao-lentes.jpg" alt="Equipamento para medição precisa de lentes" loading="lazy" />
					</div>
					<div className={styles.experienceContent}>
						<p className={styles.eyebrow}>Experiência que faz diferença</p>
						<h2>Uma recomendação pensada para você</h2>
						<p>
							Nossa equipe reúne técnicos ópticos e profissionais experientes em lentes de contato e
							óculos de grau. Aqui, cada escolha começa com escuta e orientação.
						</p>
						<ul>
							<li><span>01</span><div><strong>Atendimento especializado</strong><small>Orientação clara em cada etapa da sua escolha.</small></div></li>
							<li><span>02</span><div><strong>Variedade com qualidade</strong><small>Óculos e lentes de marcas reconhecidas.</small></div></li>
							<li><span>03</span><div><strong>Ambiente acolhedor</strong><small>Loja confortável e espaço kids para sua família.</small></div></li>
						</ul>
						<WhatsappLink className={styles.textLink} position="diferenciais">
							Converse com nossa equipe <span aria-hidden="true">→</span>
						</WhatsappLink>
					</div>
				</section>

				<section className={styles.realStoreSection}>
					<div className={styles.realStoreCopy}>
						<p className={styles.eyebrow}>Pessoas reais, cuidado de verdade</p>
						<h2>Uma ótica feita para receber bem</h2>
						<p>
							Do atendimento ao espaço kids, cada detalhe foi pensado para tornar sua visita leve,
							prática e acolhedora.
						</p>
						<a
							href="https://www.instagram.com/multilentespoa/"
							target="_blank"
							rel="noreferrer"
							className={`${styles.textLink} ${styles.instagramLink}`}
						>
							<Instagram className={styles.instagramIcon} aria-hidden="true" />
							Siga @multilentespoa no Instagram <span aria-hidden="true">→</span>
						</a>
					</div>
					<div className={styles.realStoreGallery}>
						<picture>
							<img src="/assets/selected/experiencia-multilentes.jpg" alt="Detalhes da experiência na Ótica Multilentes" loading="lazy" />
						</picture>
						<img src="/assets/selected/espaco-kids.jpg" alt="Espaço kids da Ótica Multilentes" loading="lazy" />
						<img src="/assets/selected/ambiente-atendimento.jpg" alt="Ambiente de atendimento da Ótica Multilentes" loading="lazy" />
					</div>
				</section>

				<section className={styles.reviewsSection}>
					<div>
						<p className={styles.eyebrow}>Confiança construída com o tempo</p>
						<h2>Quem conhece, recomenda</h2>
						<p>Confira as experiências compartilhadas por clientes da Multilentes no Google.</p>
					</div>
					<a
						href="https://www.google.com/maps/search/?api=1&query=%C3%93tica%20Multilentes%20Av.%20S%C3%A3o%20Pedro%20720%20Porto%20Alegre"
						target="_blank"
						rel="noreferrer"
						className={styles.reviewCard}
					>
						<span className={styles.stars} aria-label="Avaliações no Google">★★★★★</span>
						<strong>Veja as avaliações no Google</strong>
						<span>Experiências reais de quem já foi atendido →</span>
					</a>
				</section>

				<section id="localizacao" className={styles.locationSection}>
					<div className={styles.locationContent}>
						<p className={styles.eyebrow}>Visite a Multilentes</p>
						<h2>Fácil de chegar.<br />Fácil de estacionar.</h2>
						<div className={styles.locationDetails}>
							<div>
								<span className={styles.detailIcon} aria-hidden="true">⌖</span>
								<p><strong>Endereço</strong>Av. São Pedro, 720, sala 201<br />São Geraldo — Porto Alegre/RS</p>
							</div>
							<div>
								<span className={styles.detailIcon} aria-hidden="true">P</span>
								<p><strong>Estacionamento conveniado</strong>Av. São Pedro, 754 e 733</p>
							</div>
							<div>
								<span className={styles.detailIcon} aria-hidden="true">◷</span>
								<p><strong>Horários</strong>Segunda a sexta: 9h às 17h30<br />Sábado: 9h às 12h, por agendamento</p>
							</div>
						</div>
						<div className={styles.locationActions}>
							<a
								href="https://www.google.com/maps/dir/?api=1&destination=Av.%20S%C3%A3o%20Pedro%2C%20720%2C%20sala%20201%2C%20Porto%20Alegre"
								target="_blank"
								rel="noreferrer"
								className={styles.primaryCta}
							>
								<Location className={styles.buttonIcon} aria-hidden="true" focusable="false" />
								Traçar rota
							</a>
							<a href="tel:+555130120226" className={styles.secondaryCta}>
								<Phone2 className={styles.buttonIcon} aria-hidden="true" focusable="false" />
								(51) 3012-0226
							</a>
						</div>
					</div>
					<iframe
						title="Mapa da Ótica Multilentes"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3454.9254015984975!2d-51.20469048814202!3d-30.01029832959056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951979951a4956eb%3A0x3d84ec101e09c74e!2sAv.%20S%C3%A3o%20Pedro%2C%20720%20-%20201%20-%20S%C3%A3o%20Geraldo%2C%20Porto%20Alegre%20-%20RS%2C%2090230-123!5e0!3m2!1spt-BR!2sbr!4v1742847037825!5m2!1spt-BR!2sbr"
						loading="lazy"
					></iframe>
				</section>

				<section className={styles.finalCta}>
					<div>
						<p className={styles.eyebrow}>Vamos cuidar da sua visão?</p>
						<h2>Fale com a Multilentes e agende seu atendimento.</h2>
					</div>
					<WhatsappLink className={`${styles.lightCta} ${styles.whatsappCta}`} position="final">
						Falar agora no WhatsApp <span aria-hidden="true">→</span>
					</WhatsappLink>
				</section>
			</main>

			<footer className={styles.footer}>
				<div className={styles.footerBrand}>
					<img src="/assets/logoBgBlack.png" alt="Ótica Multilentes" />
					<p>Experiência e cuidado para você enxergar melhor.</p>
				</div>
				<div>
					<strong>Contato</strong>
					<a href="tel:+555130120226">(51) 3012-0226</a>
					<a href="mailto:multilentes@multilentes.com.br">multilentes@multilentes.com.br</a>
					<a href="https://www.instagram.com/multilentespoa/" target="_blank" rel="noreferrer">@multilentespoa</a>
				</div>
				<div>
					<strong>Endereço</strong>
					<span>Av. São Pedro, 720, sala 201</span>
					<span>São Geraldo — Porto Alegre/RS</span>
					<span>CEP 90230-123</span>
				</div>
				<p className={styles.copyright}>© {new Date().getFullYear()} Ótica Multilentes. Todos os direitos reservados.</p>
			</footer>

			<WppBtn url={whatsappUrl} />
		</div>
	);
}
